import { useQuery } from '@apollo/client'
import { useMemo } from 'react'
import { GRUPOS_QUERY } from '../data/grupos'
import { OptionSelect } from '../utils/types'
import { GruposAtivosQuery } from '@/core/types/graphql'

export const useGrupos = () => {
  const { data: { gruposAtivos = [] } = {}, loading } =
    useQuery<GruposAtivosQuery>(GRUPOS_QUERY)

  const gruposOptions = useMemo(
    () =>
      gruposAtivos?.map(it => ({
        label: it?.nome,
        value: it?.id
      })) as OptionSelect[],
    [gruposAtivos]
  )

  return {
    gruposOptions,
    loading
  }
}
